/* eslint-disable no-restricted-syntax */
import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import disqusMixin from '@/mixins/disqus';
import cmsContentMixin from '@/mixins/cmsContent';
import scrollTo from '@/utils/scrollTo';

export default {
  mixins: [
    cmsContentMixin,
    disqusMixin,
    loaderMixin,
  ],
  props: {
    storyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      storyContent: '',
      refreshIndex: 0,
    };
  },
  metaInfo() {
    if (this.currentStoryDetail !== null) {
      return {
        title: this.currentStoryDetail.seoTitle,
      };
    }
    return {};
  },
  computed: {
    ...mapState('browse', ['currentStoryDetail']),
  },
  watch: {
    currentStoryDetail: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.refreshIndex += 1;
          this.storyContent = `${newVal.bodyCSS || ''}${newVal.bodyHTML || ''}`;
          this.$nextTick(() => {
            this.installDynamicControls({
              data: {
                ...newVal,
              },
            });
          });
        }
      },
    },
  },
  methods: {
    ...mapActions('browse', ['getStoryDetail', 'clearCurrentStoryDetail']),
    getCanonicalStoryUrl() {
      if (!this.currentStoryDetail) {
        return '';
      }
      return (this.currentStoryDetail.storyUrl || '').trim();
    },
    syncCanonicalStoryUrl() {
      const canonicalStoryUrl = this.getCanonicalStoryUrl();
      const currentStoryUrl = ((this.$route.params || {}).storyUrl || '').trim();

      if (currentStoryUrl === canonicalStoryUrl) {
        return;
      }

      const params = {
        storyId: this.storyId,
      };
      if (canonicalStoryUrl.length > 0) {
        params.storyUrl = canonicalStoryUrl;
      }

      this.$router.replace({
        name: 'story-details',
        params,
        query: this.$route.query,
        hash: this.$route.hash,
      });
    },
  },
  mounted() {
    this.loaderAdd(document.body);
    this.getStoryDetail({ index: this.storyId })
      .then(() => {
        this.syncCanonicalStoryUrl();
        this.loaderRemove(document.body);

        if (!window.location.hash) return;

        this.$nextTick(() => {
          const elementId = window.location.hash.replace('#', '');
          const element = window.document.getElementById(elementId);
          if (element !== null) {
            scrollTo(element);
          }
        });
      })
      .catch(() => this.loaderRemove(document.body));
  },
  beforeDestroy() {
    this.clearCurrentStoryDetail();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-story-detail/page-story-detail.js